import React from "react";
import "./Home.css";

const HomeServices = () => {
 const services = [
  {
    title: "Strategy & Business Growth",
   
    items: [
      "Digital Strategy & Business Consulting",
      "Lead Generation Solutions",
      "Analytics & Growth Consulting",
    ],
  },
  {
    title: "Design & Development",
   
    items: [
      "Website Design & Development",
      "Custom Software Development",
      "Website Maintenance & Technical Support",
    ],
  },
  {
    title: "Branding & Digital Marketing",
   
    items: [
      "Branding & Brand Identity",
      "Creative Design & Visual Communication",
      "Search Engine Optimization (SEO)",
      "Performance Marketing",
      "Social Media Management",
    ],
  },
  {
    title: "Automation & AI Solutions",
   
    items: [
      "Business Automation",
      "AI-Powered Business Solutions",
    ],
  },
];

  return (
    <div className="backdiv">
      <div>

        <h2 className="main-title">
          Accelerating Growth Through <br/>Smart Digital Solutions
        </h2>

        <div className="home_service_grid">
          {services.map((s, i) => (
            <div className='service_card' key={i}>
<div>
              <h3 className="service_head">{s.title}</h3>
             

              <ul className="service_list">
                {s.items.map((item, idx) => (
                  <li key={idx}>✓ {item}</li>
                ))}
              </ul>
</div>
            </div>
          ))}
        </div>

      </div>
    </div>
  );
};

export default HomeServices;